<script setup>
const hasContent = ref(true)
</script>

<template>
  <MainContainer v-if="hasContent">
    <div class="mx-4 flex flex-col flex-gap-y-4">
      <ConditionalContainer v-model="hasContent">
        <AppOutdatedBrowserBanner />
      </ConditionalContainer>
    </div>
  </MainContainer>
</template>
